/**
 * API client for connector type metadata endpoints
 */
import { apiClient } from './client';
import type { ConnectorTypesListResponse, ConnectorTypeInfo, ConnectorType } from '@/types/connectors';
import type { ConnectorTypeSchemaResponse } from '../../types/connector-schema';

const API_BASE = '/connector-types';

/**
 * Fetch all connector types with optional filtering
 */
export async function fetchConnectorTypes(params?: {
  category?: string;
  available_only?: boolean;
  include_planned?: boolean;
}): Promise<ConnectorTypesListResponse> {
  const response = await apiClient.get(API_BASE, { params });
  return response.data;
}

/**
 * Fetch specific connector type details
 */
export async function fetchConnectorTypeDetails(type: ConnectorType): Promise<ConnectorTypeInfo> {
  const response = await apiClient.get(`${API_BASE}/${type}`);
  return response.data;
}

/**
 * Fetch field schema for a connector type
 *
 * Returns the full ConnectorTypeSchemaResponse from the backend,
 * preserving all field metadata (oauth_config, checkbox_options,
 * validations, etc.) so that downstream form components can
 * render any field type without information loss.
 */
export async function fetchConnectorTypeSchema(
  type: ConnectorType
): Promise<ConnectorTypeSchemaResponse> {
  const response = await apiClient.get(`${API_BASE}/${type}/schema`);
  return response.data as ConnectorTypeSchemaResponse;
}

/**
 * Export connector types endpoints
 */
export const connectorTypesEndpoints = {
  list: fetchConnectorTypes,
  get: fetchConnectorTypeDetails,
  schema: fetchConnectorTypeSchema,
};
